import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { tap, switchMap } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';

import { ActionService, ProcessService, UserService, SimulationService } from 'src/app/services';
import { Action, Process, StepSimulation, Simulation, StepName } from 'src/app/models';
import { stringToSlug } from 'src/app/utils/stringToSlug';

interface User {
  nombre: string;
  correo?: string;
}

@Component({
  selector: 'app-crear-proceso',
  templateUrl: './crear-proceso.component.html',
  styleUrls: ['./crear-proceso.component.css']
})

export class CrearProcesoComponent implements OnInit {
  @ViewChild('txtBuscar') txtBuscar!: ElementRef<HTMLInputElement>;

  searchText: { [key: string]: string } = {};



  actions: Action[] = [];
  processes: Process[] = [];
  steps: StepSimulation[] = [];
  //allUsers: string[] = [];
  allUsers: { nombre: string; correo: string }[] = [];
  //filteredUsers: { [key: string]: string[] } = {};
  filteredUsers: { [key: string]: { nombre: string; correo: string }[] } = {};
  simulation!: Simulation;
  simulationForm: UntypedFormGroup;

  juezControl = new UntypedFormControl('', Validators.required);

  constructor(
    public dialogRef: MatDialogRef<CrearProcesoComponent>,
    private processService: ProcessService,
    private simulationService: SimulationService,
    private actionService: ActionService,
    private userService: UserService,
    private fb: UntypedFormBuilder
  ) {
    this.simulationForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      action: [{ value: '', disabled: true }, [Validators.required]],
      process: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      zoomAudience: ['', [Validators.required, Validators.minLength(3)]],
      juez: this.juezControl,
      ab_demandante: [[], [Validators.required, Validators.minLength(1)]],
      ab_defensor: [[], [Validators.required, Validators.minLength(1)]],
      secretario: ['', [Validators.required]],
    });
  }


  ngOnInit() {
    this.processService.getProcesses().subscribe(
      process => this.processes = process
    );

    /*this.userService.getAllStudent().subscribe(
      usuarios => {
        this.allUsers = usuarios.map(user => user.displayName!).sort();
        this.initializeFilteredUsers();
      }
    );*/

    this.userService.getAllStudent().subscribe(usuarios => {
      this.allUsers = usuarios.map(user => ({
        nombre: user.displayName! || '',
        correo: user.mail! || ''
      }));
      this.initializeFilteredUsers();
    });


    this.simulationForm.get('process')?.valueChanges.pipe(
      tap((_) => {
        this.simulationForm.get('action')?.reset('');
        this.simulationForm.get('action')?.enable();
      }),
      switchMap(process => this.actionService.getActionByProcess(process)),
    ).subscribe((actions: any) => {
      this.actions = actions;
    });

    ['juez', 'ab_demandante', 'ab_defensor', 'secretario'].forEach(field => {
      this.simulationForm.get(field)?.valueChanges.subscribe(() => this.updateFilteredUsers());
    });
  }

  initializeFilteredUsers() {
    ['juez', 'ab_demandante', 'ab_defensor', 'secretario'].forEach(field => {
      this.filteredUsers[field] = [...this.allUsers];
      this.searchText[field] = ''; // Inicializar searchText
    });
  }

  updateFilteredUsers(): void {
    this.actualizarFiltros();
  }

  /*
    filtrarUsuarios1($event: any, field: string) {
      $event.preventDefault();
      const valor = $event.target.value.toLowerCase();
      if (valor.trim() === '') {
        this.filteredUsers[field] = this.allUsers;
        return;
      }
      this.filteredUsers[field] = this.allUsers.filter(user =>
        //user.toLowerCase.includes(valor) &&
        (!this.simulationForm.get(field)?.value || user === this.simulationForm.get(field)?.value) &&
        !this.isUserSelectedInOtherFields(user, field)
      );
    }*/

  filtrarUsuarios($event: any, field: string): void {
    const valor = $event.target.value.toLowerCase();
    const multiFields = ['ab_demandante', 'ab_defensor'];

    this.filteredUsers[field] = this.allUsers.filter(user => {
      const coincide = user.nombre.toLowerCase().includes(valor) || user.correo.toLowerCase().includes(valor);
      const yaEnOtroCampo = this.isSelectedInOtherField(user, field);

      if (multiFields.includes(field)) {
        const seleccionados: any[] = this.simulationForm.get(field)?.value ?? [];
        const esSeleccionadoAqui = seleccionados.some((u: any) => u.nombre === user.nombre);
        return coincide && (!yaEnOtroCampo || esSeleccionadoAqui);
      }
      const esSeleccionadoEnEsteCampo = this.simulationForm.get(field)?.value?.correo === user.correo;
      return coincide && (!yaEnOtroCampo || esSeleccionadoEnEsteCampo);
    });
  }


  /*private isUserSelectedInOtherFields(user: string, currentField: string): boolean {
    const fields = ['juez', 'ab_demandante', 'ab_defensor', 'secretario'];
    return fields.some(field =>
      field !== currentField && this.simulationForm.get(field)?.value === user
    );
  }*/

  private isUserSelectedInOtherFields(nombre: string, currentField: string): boolean {
    const fields = ['juez', 'ab_demandante', 'ab_defensor', 'secretario'];
    return fields.some(field =>
      field !== currentField &&
      this.simulationForm.get(field)?.value === nombre
    );
  }



  limpiarBuscador(field: string, input: HTMLInputElement): void {
    input.value = '';
    this.filteredUsers[field] = this.allUsers.filter(user =>
      !this.isUserSelectedInOtherFields(user.nombre, field)
    );
  }

  limpiarBuscador1(field: string) {
    this.searchText[field] = '';
    this.filteredUsers[field] = [...this.allUsers];
  }



  focusBuscador() {
    setTimeout(() => {
      this.txtBuscar?.nativeElement?.focus();
    }, 0);
  }

  seleccionarUsuario(usuario: any, field: string): void {
    this.simulationForm.get(field)?.setValue(usuario);
    this.actualizarFiltros(); // Recalcula para todos
  }


  eliminarUsuario(field: string): void {
    this.simulationForm.get(field)?.setValue(null);
    this.actualizarFiltros();
  }


  campoNoValido(campo: string): boolean {
    return this.simulationForm.get(campo)?.invalid &&
      (this.simulationForm.get(campo)?.touched || this.simulationForm.get(campo)?.dirty) || false;
  }

  getNombres(field: string): string {
    const val: any[] = this.simulationForm.get(field)?.value ?? [];
    return val.map((u: any) => u.nombre).join(', ');
  }

  get identifier() {
    const date = new Date();
    const dateParse = date.getTime().toString();
    const id = dateParse.slice(dateParse.length - 4, dateParse.length);
    const actionSelected = this.simulationForm.get('action')?.value.trim().slice(0, 3);
    const processSelected = this.simulationForm.get('process')?.value.trim().slice(0, 3);
    const nameSplit = this.simulationForm.get('name')?.value.trim().split(' ')[0];
    return `${nameSplit}-${actionSelected}-${processSelected}-${id}`;
  }

  closeCreateSimulation() {
    this.dialogRef.close();
  }

  createSimulation() {

    if (this.simulationForm.invalid) {
      this.simulationForm.markAllAsTouched();
      return;
    }

    const stepName: StepName = 'Demanda';
    this.steps.push({
      name: stepName,
      slug: stringToSlug(stepName),
      route: stringToSlug(stepName),
    })

    const raw = this.simulationForm.value;

    const selectedProcessId = this.simulationForm.get('process')?.value;
    const selectedProcess = this.processes.find(p => p.id === selectedProcessId);

    this.simulation = {
      ...raw,
      identifier: this.identifier,
      create: new Date(),
      steps: this.steps,
      status: 'created',
      category: selectedProcess?.name ?? 'Sin categoría',
      juez: raw.juez?.nombre ?? null,
      ab_demandante: (raw.ab_demandante as any[]).map((u: any) => u.nombre),
      ab_defensor: (raw.ab_defensor as any[]).map((u: any) => u.nombre),
      secretario: raw.secretario?.nombre ?? null,
    };

    this.simulationService.postSimulation(this.simulation);
    this.dialogRef.close();

  }

  onSelectOpened(tipo: string) {
    // Limpiar la búsqueda al abrir
    this.searchText[tipo] = '';
    this.updateFilteredUsers(); // Usar tu método existente
  }

  getUsuarioPorCorreo(nombre: string): { nombre: string, correo: string } | undefined {
    return this.allUsers.find(user => user.nombre === nombre);
  }

  private isSelectedInOtherField(user: { nombre: string; correo: string }, campo: string): boolean {
    const singularFields = ['juez', 'secretario'];
    const multiFields = ['ab_demandante', 'ab_defensor'];
    const allFields = [...singularFields, ...multiFields];

    return allFields.some(key => {
      if (key === campo) return false;
      const val = this.simulationForm.get(key)?.value;
      if (multiFields.includes(key)) {
        return Array.isArray(val) && val.some((u: any) => u.nombre === user.nombre);
      }
      return val && val.nombre === user.nombre;
    });
  }

  actualizarFiltros(): void {
    const campos = ['juez', 'ab_defensor', 'ab_demandante', 'secretario'];
    campos.forEach(campo => {
      const multiFields = ['ab_demandante', 'ab_defensor'];
      this.filteredUsers[campo] = this.allUsers.filter(user => {
        const yaEnOtroCampo = this.isSelectedInOtherField(user, campo);
        if (multiFields.includes(campo)) {
          const seleccionados: any[] = this.simulationForm.get(campo)?.value ?? [];
          const esSeleccionadoAqui = seleccionados.some((u: any) => u.nombre === user.nombre);
          return !yaEnOtroCampo || esSeleccionadoAqui;
        }
        const esSeleccionadoAqui = this.simulationForm.get(campo)?.value?.nombre === user.nombre;
        return !yaEnOtroCampo || esSeleccionadoAqui;
      });
    });
  }

}
